module.exports = __webpack_public_path__ + "static/couture02-a0cdd6f29ef866c4f240cba9a3d0bee0.png";